import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/subMonths/index.js';

var require$$16 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$16 as default };
